export function StatusBadge({ status }: { status: string }) {
  const normalized = status.toLowerCase();
  const tone =
    normalized.includes("hyväksytty") || normalized === "valmis"
      ? "success"
      : normalized.includes("virhe") || normalized.includes("hylätty")
        ? "danger"
        : normalized.includes("manuaal") || normalized.includes("odottaa")
          ? "warning"
          : "info";
  return <span className={`badge badge--${tone}`}>{status}</span>;
}

